import "./tarifsNavbar.css";

import TarifsNavButton from "./tarifsNavButton";
import TarifsNavSectionTitle from "./tarifsNavSectionTitle";

function TarifsNavbar() {
  return (
    <div className="tarifs-details-navbar-main">
      <div className="tarifs-details-navbar-section">
        <div className="tarifs-details-navbar-section-list">
          <TarifsNavButton id={0} first={true}>
            Diagnostic
          </TarifsNavButton>
          <TarifsNavButton id={1}>Changement de composant</TarifsNavButton>
          <TarifsNavButton id={2}>
            Désinfection des virus et malwares
          </TarifsNavButton>
        </div>
        <TarifsNavSectionTitle first={true}>Panne</TarifsNavSectionTitle>
      </div>
      <div className="tarifs-details-navbar-section">
        <div className="tarifs-details-navbar-section-list">
          <TarifsNavButton id={4}>Dépoussièrage</TarifsNavButton>
          <TarifsNavButton id={5}>Accélération du système</TarifsNavButton>
          <TarifsNavButton id={6}>
            (ré)Installation du système d'exploitation (Windows, MacOS, Linux)
          </TarifsNavButton>
          <TarifsNavButton id={7}>Reconditionnement</TarifsNavButton>
        </div>
        <TarifsNavSectionTitle>Maintenance Préventive</TarifsNavSectionTitle>
      </div>
      <div className="tarifs-details-navbar-section">
        <div className="tarifs-details-navbar-section-list">
          <TarifsNavButton id={8}>
            Conseils Achat / Informatique
          </TarifsNavButton>
          <TarifsNavButton id={9}>
            Montage PC sur mesure / Gaming
          </TarifsNavButton>
        </div>
        <TarifsNavSectionTitle>Conseils et Divers</TarifsNavSectionTitle>
      </div>
      <div className="tarifs-details-navbar-section">
        <div className="tarifs-details-navbar-section-list">
          <TarifsNavButton id={10}>
            Forfait / contrat de Maintenance
          </TarifsNavButton>
          <TarifsNavButton id={11}>Developpement logiciel</TarifsNavButton>
          <TarifsNavButton id={12} last={true}>
            Developpement Site Web
          </TarifsNavButton>
        </div>
        <TarifsNavSectionTitle last={true}>
          Services aux entreprises
        </TarifsNavSectionTitle>
      </div>
      <div className="tarifs-details-navbar-fillerA">
        <div className="tarifs-details-navbar-fillerB"></div>
      </div>
    </div>
  );
}

export default TarifsNavbar;
